export default "__VITE_ASSET__BtLvPA7f__"